import ModalBase from './base';
import { buildScriptTag } from "../common/evite/dom"
import { htmlFromString } from '../common/utils';
import uuid from 'uuid';

class EviteModal {

    target = null;
    modalHead = null;
    modalBody = null;
    parser = null;
    open = false;
    id = null;
    defaults = {
        popup: false,
        width: "480px",
        parse: true,
    };

    constructor(settings) {
        this.settings = {
            ...this.defaults,
            ...settings
        };
        this.id = uuid.v1();
        this.modal = ModalBase.getInstance();
        this.parser = this.modal.parser;
        this.buildContainer();
    }

    buildContainer() {
        this.target = htmlFromString(`<div id="eviteModal-${this.id}" class="eviteModalContentOuter"><div class="eviteModalContainer"><div class="eviteModalContent"></div></div></div>`);
        this.target.querySelector('.eviteModalContainer').style.cssText = `
            background: white;
            max-width: ${this.settings.width};
            border: 1px solid #A8A8A8;
            border-radius: 6px;
            overflow: hidden;`;
    }

    encodeUrlParams(data) {
       let ret = [];
       for (let d in data)
         ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
       return ret.join('&');
    }

    _query_string() {
        let params = {
          p: JSON.stringify(this.settings.url_parameters),
          parent_url: document.location.href,
        };
        return '?' + this.encodeUrlParams(params);
    };

    fetchContent = () => {
        let url =  this.settings.url;
        url +=  this.settings.url_parameters ? this._query_string() : '';
        return new Promise((resolve, reject) => {
            window.evite.fetch(url, {
                    method: 'get',
                    credentials: "same-origin",
                    cache: 'no-cache'
                }
            )
            .then(response => {
                resolve(response.text())
            })
            .catch(message => {
                reject(message);
            });

        })
    };

    parseContent = (text) => {
        return this.parser.parseFromString(text, "text/html")
    };

    injectContent = (page) => {
        this.modalHead = page.head;
        this.modalBody = page.body.innerHTML;
        this.target.querySelector('.eviteModalContent').innerHTML = this.modalBody;
        return this
    };

    showLoader = () => {
      this.loader = document.querySelector('.insideLoader');
      this.loader.style.display = 'block';
    };

    hideLoader = () => {
      this.loader = document.querySelector('.insideLoader');
      this.loader.style.display = 'none';
    };

    buildPopup() {
        return new Promise((resolve, reject) => {
            if (!this.settings.body) {
                reject('"body" is required') ;
            }
            if (!this.settings.title) {
                reject('"title" is required');
            }
            if (!this.settings.buttons) {
                reject('"buttons" is required');
            }
            const buttons = this.settings.buttons;
            let button_markup = '';
            for(let key in buttons) {
                let button = buttons[key];
                if (buttons.length === (1 * key + 1)) {
                    button_markup += `<a class="button-primary" data-name="${button}" data-index="${key}">${button}</a>`;
                } else {
                    button_markup += `<a class="button-primary-inverse" data-name="${button}" data-index="${key}">${button}</a>`;
                }
            }
            let modalContent;
            if (this.settings.parse) {
                modalContent = `<p>${this.settings.body}</p>`
            }
            const container = this.target.querySelector('.eviteModalContent');
            container.innerHTML = `
                <div class='popup-modal'>
                    <div class="modal-header">
                        <h1>${this.settings.title}</h1>
                    </div>
                    <div class="modal-body">
                        <div class="wrapper">${modalContent || ''}</div>
                    </div>
                    <div class="modal-footer">${button_markup}</div>
                </div>
            `;
            
            if (!this.settings.parse) {
                container.querySelector('.wrapper').appendChild(this.settings.body)
            }

            let self = this;
            function respondToPopup(e) {
                self.close();
                if(self.settings.onResponse)
                    self.settings.onResponse.apply(self, [e, self]);
            }

            for(let key of Object.keys(this.settings.buttons)) {
              container.querySelectorAll('.modal-footer a')[key].addEventListener('click', respondToPopup);
            }
            resolve(true);
        });
    }

    parseDependencies = () => {
        let scripts = Array.from(this.modalHead.querySelectorAll('script'));
        let links = Array.from(this.modalHead.querySelectorAll('link'));
        let styles = links.filter((link) => link.type ==="text/css");
        styles.forEach((style) => {
            style.className = 'eviteModalStyle';
            document.head.appendChild(style)
        });
        scripts.forEach((script) => {
            let scriptTag;
            let src = script.getAttribute('src');
            if (src) {
                scriptTag = buildScriptTag({
                    src: src,
                    type: 'text/javascript',
                    async: true,
                    className: 'eviteModalScript',
                    onLoad: () => false
                });
            } else {
                scriptTag = buildScriptTag({
                    type: 'text/javascript',
                    innerHTML: script.innerHTML,
                    className: 'eviteModalScript',
                    onLoad: () => false
                });
            }
            document.head.appendChild(scriptTag);
        });
        return this
    };

    buildRemote() {
        return new Promise((resolve, reject) => {
            this.fetchContent()
                .then(text => this.parseContent(text))
                .then(page => this.injectContent(page))
                .then(this.parseDependencies)
                .then(resolve)
                .catch((msg) => reject(msg))
        })
    }

    buildFromResponse = (serverResponse) => {
        const page = this.parseContent(serverResponse);
        this.injectContent(page);
        this.parseDependencies();
    };


    close = () => {
        return new Promise((resolve, reject) => {
            if (this.open) {
                this.modal.close().then(() => {
                    this.open = false;
                    const modalDom = document.getElementById(`eviteModal-${this.id}`);
                    const styles = document.querySelectorAll('.eviteModalStyle');
                    const scripts = document.querySelectorAll('.eviteModalScript');
                    Array.from(styles).forEach((el) => el.parentNode.removeChild(el));
                    Array.from(scripts).forEach((el) => el.parentNode.removeChild(el));
                    if (modalDom) modalDom.parentNode.removeChild(modalDom);
                    resolve();
                });
            }
        })

    };

    respond = (options, settings) => {
        this.modal.respond(options, settings);
    };

    show(htmlResponse) {
        document.querySelector('body').appendChild(this.target);
        this.modal.initialize(this);
        if (htmlResponse && !this.settings.popup) {
            this.buildFromResponse(htmlResponse);
            this.modal.open(`#eviteModal-${this.id}`);
            this.open = true;
            return
        }
        if (this.settings.popup) {
            this.buildPopup().then(() => {
                this.modal.open(`#eviteModal-${this.id}`);
                this.open = true;
            })
        }
        else {
            this.buildRemote().then(() => {
                this.modal.open(`#eviteModal-${this.id}`);
                this.open = true;
            });
        }

    }

}

export default EviteModal


// WEBPACK FOOTER //
// ./assets/es6/modal/evite_modal.es6